<template>
  <v-sheet>
    <v-overlay opacity="0.2" absolute :value="onloading">
      <v-progress-circular indeterminate color="purple" width="3" size="30"></v-progress-circular>
    </v-overlay>
    <div class="container" v-html="item[$store.state.lang+'_content']"></div>
  </v-sheet>
</template>

<script>

export default {
  name: 'Item',
  data(){
    return{
      item_io_api:'item/io/',
      item:{},
      onloading:false,
    }
  },
  props:{
    childid:{
      type:Number,
    },
    family:{
      type:String,
    },
  },
  methods:{
    fetch(){
      this.onloading = true;
      let postdata = {};
      postdata.flag = this.childid;
      postdata.family = this.family;
      this.$axios.post(this.$store.state.baseurl + this.item_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.item = response.data.data;
                this.$emit('get_item',this.item);
                this.onloading = false;
              }
            }
          )
          .catch(function (e){})
    },
  },
  mounted(){
    this.fetch();
  },
  watch:{
    childid(){
      this.fetch();
    }
  }
}
</script>

<style scoped>

</style>
